var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaybackward(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.004 18.3217C19.024 19.1057 20.5 18.3787 20.5 17.0927V6.90473C20.5 5.61873 19.024 4.89173 18.004 5.67573L11.78 10.8677C11.6143 11.006 11.481 11.1789 11.3896 11.3744C11.2981 11.5698 11.2507 11.7829 11.2507 11.9987C11.2507 12.2145 11.2981 12.4277 11.3896 12.6231C11.481 12.8185 11.6143 12.9915 11.78 13.1297L18.004 18.3217Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.754 18.3217C9.774 19.1057 11.25 18.3787 11.25 17.0927V6.90473C11.25 5.61873 9.774 4.89173 8.754 5.67573L2.53 10.8677C2.36432 11.006 2.23103 11.1789 2.13957 11.3744C2.04811 11.5698 2.0007 11.7829 2.0007 11.9987C2.0007 12.2145 2.04811 12.4277 2.13957 12.6231C2.23103 12.8185 2.36432 12.9915 2.53 13.1297L8.754 18.3217Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaybackward);
export default __webpack_public_path__ + "static/media/playbackward.cc0b23c3e505d8db30906e53013f7d85.svg";
export { ForwardRef as ReactComponent };